import { FloatingPanel } from "@ark-ui/react";
import { Fragment, ReactNode } from "react";
import { LuArrowDownLeft, LuMaximize2, LuMinus, LuX } from "react-icons/lu";

import { sva } from "../../styled-system/css";

export const floatingPanelStyles = sva({
  slots: [
    "closeTrigger",
    "content",
    "body",
    "header",
    "control",
    "resizeTriggerN",
    "resizeTriggerE",
    "resizeTriggerS",
    "resizeTriggerW",
    "resizeTriggerNe",
    "resizeTriggerSe",
    "resizeTriggerSw",
    "resizeTriggerNw",
    "stateTrigger",
  ],
  base: {
    content: {
      backgroundColor: "background",
      borderColor: "border",
      borderRadius: "8px",
      borderStyle: "solid",
      borderWidth: "1px",
      boxShadow: "rgba(0, 0, 0, 0.28) 0px 16px 18px 0px, rgba(0, 0, 0, 0.12) 0px 4px 16px 0px",
      display: "flex",
      flexDirection: "column",
      outline: "0 !important",
      overflow: "clip",
      "&[data-topmost]": { zIndex: 999999 },
      "&[data-behind]": { opacity: 0.4 },
    },
    body: {
      backgroundColor: "white",
      flex: 1,
      overflow: "auto",
      position: "relative",
    },
    header: {
      alignItems: "center",
      backgroundColor: "sidebar-background",
      borderColor: "border",
      borderStyle: "solid",
      borderBottomWidth: "1px",
      display: "flex",
      justifyContent: "space-between",
      paddingX: "12px",
      paddingY: "4px",
    },
    closeTrigger: {
      cursor: "pointer",
      padding: "8px",
      "&:hover": { backgroundColor: "destructive/10" },
      "&:focus": { backgroundColor: "destructive/20" },
      "&:active": { backgroundColor: "destructive/30" },
    },
    control: { alignItems: "center", display: "flex", gap: "2px" },
    resizeTriggerN: { height: "8px", maxWidth: "calc(100% - 16px)" },
    resizeTriggerE: { maxHeight: "calc(100% - 16px)", width: "8px" },
    resizeTriggerS: { height: "8px", maxWidth: "calc(100% - 16px)" },
    resizeTriggerW: { maxHeight: "calc(100% - 16px)", width: "8px" },
    resizeTriggerNe: { width: "8px", height: "8px" },
    resizeTriggerSe: { width: "8px", height: "8px" },
    resizeTriggerSw: { width: "8px", height: "8px" },
    resizeTriggerNw: { width: "8px", height: "8px" },
    stateTrigger: {
      cursor: "pointer",
      padding: "8px",
      "&:hover": { backgroundColor: "muted-foreground/10" },
      "&:focus": { backgroundColor: "muted-foreground/20" },
      "&:active": { backgroundColor: "muted-foreground/30" },
    },
  },
});

export type FloatingPanelBorderProperties = Record<string, never>;

export function FloatingPanelBorder(_: FloatingPanelBorderProperties) {
  const classes = floatingPanelStyles();
  return (
    <Fragment>
      <FloatingPanel.ResizeTrigger axis="n" className={classes.resizeTriggerN} />
      <FloatingPanel.ResizeTrigger axis="e" className={classes.resizeTriggerE} />
      <FloatingPanel.ResizeTrigger axis="s" className={classes.resizeTriggerS} />
      <FloatingPanel.ResizeTrigger axis="w" className={classes.resizeTriggerW} />
      <FloatingPanel.ResizeTrigger axis="ne" className={classes.resizeTriggerNe} />
      <FloatingPanel.ResizeTrigger axis="se" className={classes.resizeTriggerSe} />
      <FloatingPanel.ResizeTrigger axis="sw" className={classes.resizeTriggerSw} />
      <FloatingPanel.ResizeTrigger axis="nw" className={classes.resizeTriggerNw} />
    </Fragment>
  );
}

export type FloatingPanelHeaderProperties = {
  title: ReactNode;
};
export function FloatingPanelHeader({ title }: FloatingPanelHeaderProperties) {
  const classes = floatingPanelStyles();
  return (
    <FloatingPanel.DragTrigger>
      <FloatingPanel.Header className={classes.header}>
        <FloatingPanel.Title>{title}</FloatingPanel.Title>
        <FloatingPanel.Control className={classes.control}>
          <FloatingPanel.StageTrigger className={classes.stateTrigger} stage="minimized">
            <LuMinus />
          </FloatingPanel.StageTrigger>
          <FloatingPanel.StageTrigger className={classes.stateTrigger} stage="maximized">
            <LuMaximize2 />
          </FloatingPanel.StageTrigger>
          <FloatingPanel.StageTrigger className={classes.stateTrigger} stage="default">
            <LuArrowDownLeft />
          </FloatingPanel.StageTrigger>
          <FloatingPanel.CloseTrigger className={classes.closeTrigger}>
            <LuX />
          </FloatingPanel.CloseTrigger>
        </FloatingPanel.Control>
      </FloatingPanel.Header>
    </FloatingPanel.DragTrigger>
  );
}
